// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #f8f9fa;
}

.project-card {
  background-color: white;
  margin-bottom: 20px;
  padding: 20px;
  border-radius: var(--border-radius);
}
.project-card a {
  color: #3b7ea1;
}

.white-container {
  background-color: white;
}
.inside-container {
  background-color: #f8f9fa;
}

.inside-btn-delete,
.inside-btn-delete:active,
.inside-btn-delete:visited {
  font-size: 16px;
  background-color: white;
  border: 1px solid #620000;
  color: #620000;
  padding: var(--button-padding);
}

.inside-btn-delete:hover {
  border-color: #a13b3b !important;
  background-color: rgba(98, 0, 0, 0.1) !important;
}
.inside-btn-download,
.inside-btn-download:active,
.inside-btn-download:visited {
  font-size: 16px;
  background-color: white;
  border: 1px solid #006200;
  color: #006200;
  padding: var(--button-padding);
  margin-right: 16px;
}

.inside-btn-download:hover {
  border-color: #3ba13b !important;
  background-color: rgba(0, 98, 0, 0.1) !important;
  margin-right: 16px;
}

a.link-button {
  background: rgba(59, 126, 161, 1);
  padding: var(--button-padding);
  color: white;
  font-weight: 600;
}
.link-button:hover {
  background: rgba(59, 126, 161, 0.8);
  color: white;
}

.project-name {
  font-size: 1.2rem;
  font-weight: bold;
  background-color: #003262;
  color: white;
  margin: -20px -21px 16px -21px;
  padding: 8px 20px;
  border-top-right-radius: var(--border-radius);
  border-top-left-radius: var(--border-radius);
}

.project-name.gray {
  background-color: #eee;
  margin: -20px -20px 16px -20px;
  color: black;
}
.project-name.flex {
  display: flex;
  justify-content: space-between;
}

.project-row-date {
  max-width: 100px;
  font-size: 0.8em;
}

.project-head-date {
  margin: 10px;
}

.project-row-inputs {
  font-size: 0.8em;
  overflow-wrap: break-word;
  word-wrap: break-word;
  max-width: 400px;
}

.announcement-link {
  color: #3b7ea1;
  text-underline-offset: 3px;
}

.announcement-link:hover {
  color: #003262;
  text-underline-offset: 3px;
}

.announcement-sub {
  font-weight: bold;
  margin-bottom: 0.3em;
}

.announcement-date {
  font-size: 0.8em;
  margin-bottom: 0.3em;
  color: #888;
}

.purchase-container {
  background-color: white;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 10px 10px 10px 10px;
  border-color: lightgray;
  border-width: 3px;
  border-radius: var(--border-radius);
}

.term-emphasis {
  font-weight: 600;
}

.side-bar-column {
  background-color: white;
  border: 1px solid lightgray;
  border-radius: var(--border-radius);
  margin-bottom: 40px;
}
.side-bar-column .account-link {
  font-weight: 600;
  padding: 0.25rem 0 0.25rem 10px;
}
.side-bar-column .account-link a {
  text-decoration: none;
}

table {
  display: inline-block;
}
table td,
table th {
  padding: 2px 20px 2px 0;
}
.account-table {
  margin-bottom: 40px;
}
.account-table td:first-child {
  font-size: 0.9em;
  font-weight: 600;
  vertical-align: top;
}
.invoice-table {
  border-collapse: collapse;
  font-size: 0.9em;
}
.invoice-table th {
  padding: 4px 20px;
}
.invoice-table td {
  border: 1px solid lightgray;
  padding: 4px 20px;
}

.auth-wrapper {
  position: relative;
}
.auth-modal {
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}
.auth-modal > div {
  background-color: white;
  padding: 20px 40px;
  border: 1px solid #003262;
  border-radius: var(--border-radius);
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
  flex-direction: column;
  gap: 20px;
  text-align: center;
}
.delete-gear {
  border: 1px solid #620000;
  color: #620000;
  width: 30px;
  border-radius: var(--border-radius);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.delete-gear:hover {
  border-color: #a13b3b !important;
  background-color: rgba(98, 0, 0, 0.1) !important;
}
`, "",{"version":3,"sources":["webpack://./src/routes/inside.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mCAAmC;AACrC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,gDAAgD;AAClD;AACA;;;EAGE,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,iBAAiB;EACjB,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gCAAgC;EAChC,gDAAgD;AAClD","sourcesContent":["body {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.project-card {\r\n  background-color: white;\r\n  margin-bottom: 20px;\r\n  padding: 20px;\r\n  border-radius: var(--border-radius);\r\n}\r\n.project-card a {\r\n  color: #3b7ea1;\r\n}\r\n\r\n.white-container {\r\n  background-color: white;\r\n}\r\n.inside-container {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.inside-btn-delete,\r\n.inside-btn-delete:active,\r\n.inside-btn-delete:visited {\r\n  font-size: 16px;\r\n  background-color: white;\r\n  border: 1px solid #620000;\r\n  color: #620000;\r\n  padding: var(--button-padding);\r\n}\r\n\r\n.inside-btn-delete:hover {\r\n  border-color: #a13b3b !important;\r\n  background-color: rgba(98, 0, 0, 0.1) !important;\r\n}\r\n.inside-btn-download,\r\n.inside-btn-download:active,\r\n.inside-btn-download:visited {\r\n  font-size: 16px;\r\n  background-color: white;\r\n  border: 1px solid #006200;\r\n  color: #006200;\r\n  padding: var(--button-padding);\r\n  margin-right: 16px;\r\n}\r\n\r\n.inside-btn-download:hover {\r\n  border-color: #3ba13b !important;\r\n  background-color: rgba(0, 98, 0, 0.1) !important;\r\n  margin-right: 16px;\r\n}\r\n\r\na.link-button {\r\n  background: rgba(59, 126, 161, 1);\r\n  padding: var(--button-padding);\r\n  color: white;\r\n  font-weight: 600;\r\n}\r\n.link-button:hover {\r\n  background: rgba(59, 126, 161, 0.8);\r\n  color: white;\r\n}\r\n\r\n.project-name {\r\n  font-size: 1.2rem;\r\n  font-weight: bold;\r\n  background-color: #003262;\r\n  color: white;\r\n  margin: -20px -21px 16px -21px;\r\n  padding: 8px 20px;\r\n  border-top-right-radius: var(--border-radius);\r\n  border-top-left-radius: var(--border-radius);\r\n}\r\n\r\n.project-name.gray {\r\n  background-color: #eee;\r\n  margin: -20px -20px 16px -20px;\r\n  color: black;\r\n}\r\n.project-name.flex {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.project-row-date {\r\n  max-width: 100px;\r\n  font-size: 0.8em;\r\n}\r\n\r\n.project-head-date {\r\n  margin: 10px;\r\n}\r\n\r\n.project-row-inputs {\r\n  font-size: 0.8em;\r\n  overflow-wrap: break-word;\r\n  word-wrap: break-word;\r\n  max-width: 400px;\r\n}\r\n\r\n.announcement-link {\r\n  color: #3b7ea1;\r\n  text-underline-offset: 3px;\r\n}\r\n\r\n.announcement-link:hover {\r\n  color: #003262;\r\n  text-underline-offset: 3px;\r\n}\r\n\r\n.announcement-sub {\r\n  font-weight: bold;\r\n  margin-bottom: 0.3em;\r\n}\r\n\r\n.announcement-date {\r\n  font-size: 0.8em;\r\n  margin-bottom: 0.3em;\r\n  color: #888;\r\n}\r\n\r\n.purchase-container {\r\n  background-color: white;\r\n  margin-top: 10px;\r\n  margin-bottom: 10px;\r\n  padding: 10px 10px 10px 10px;\r\n  border-color: lightgray;\r\n  border-width: 3px;\r\n  border-radius: var(--border-radius);\r\n}\r\n\r\n.term-emphasis {\r\n  font-weight: 600;\r\n}\r\n\r\n.side-bar-column {\r\n  background-color: white;\r\n  border: 1px solid lightgray;\r\n  border-radius: var(--border-radius);\r\n  margin-bottom: 40px;\r\n}\r\n.side-bar-column .account-link {\r\n  font-weight: 600;\r\n  padding: 0.25rem 0 0.25rem 10px;\r\n}\r\n.side-bar-column .account-link a {\r\n  text-decoration: none;\r\n}\r\n\r\ntable {\r\n  display: inline-block;\r\n}\r\ntable td,\r\ntable th {\r\n  padding: 2px 20px 2px 0;\r\n}\r\n.account-table {\r\n  margin-bottom: 40px;\r\n}\r\n.account-table td:first-child {\r\n  font-size: 0.9em;\r\n  font-weight: 600;\r\n  vertical-align: top;\r\n}\r\n.invoice-table {\r\n  border-collapse: collapse;\r\n  font-size: 0.9em;\r\n}\r\n.invoice-table th {\r\n  padding: 4px 20px;\r\n}\r\n.invoice-table td {\r\n  border: 1px solid lightgray;\r\n  padding: 4px 20px;\r\n}\r\n\r\n.auth-wrapper {\r\n  position: relative;\r\n}\r\n.auth-modal {\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.auth-modal > div {\r\n  background-color: white;\r\n  padding: 20px 40px;\r\n  border: 1px solid #003262;\r\n  border-radius: var(--border-radius);\r\n  height: 200px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-top: 100px;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  text-align: center;\r\n}\r\n.delete-gear {\r\n  border: 1px solid #620000;\r\n  color: #620000;\r\n  width: 30px;\r\n  border-radius: var(--border-radius);\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.delete-gear:hover {\r\n  border-color: #a13b3b !important;\r\n  background-color: rgba(98, 0, 0, 0.1) !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
